import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import type { QuestionModel } from '../../logic';
import { SingleSelect, SingleSelectModel } from './SingleSelect';
import { MultiSelect, MultiSelectModel } from './MultiSelect';
import { GraphicSelect, GraphicSelectModel } from './GraphicSelect';
import { Text, TextModel } from './Text';
import { Matrix, MatrixModel } from './Matrix';

export type AnswersViewProps<T extends QuestionModel = QuestionModel> = {
  questionModel: T;
};

export const AnswersView: FC<AnswersViewProps> = observer(({ questionModel }) => {
  switch (true) {
    case questionModel instanceof SingleSelectModel:
      return <SingleSelect questionModel={questionModel} />;
    case questionModel instanceof MultiSelectModel:
      return <MultiSelect questionModel={questionModel} />;
    case questionModel instanceof GraphicSelectModel:
      return <GraphicSelect questionModel={questionModel} />;
    case questionModel instanceof TextModel:
      return <Text questionModel={questionModel} />;
    case questionModel instanceof MatrixModel:
      return <Matrix questionModel={questionModel} />;
    default:
      return null;
  }
});
